import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import NewsPage from '../news/page';
import NewsDetailPage from './page';
import NotFound from '../NotFound';
// @ts-ignore
import { getNewCategories } from '../../services/newCategoryService';

interface Category {
  _id: string;
  slug: string;
  name: string;
}

type PageType = 'loading' | 'category' | 'detail' | 'notfound';

/**
 * Component middleware để xử lý routing cho tin tức
 * - /tin-tuc-{slug} → Trang danh mục (nếu slug là category hợp lệ)
 * - /tin-tuc/{slug} → Trang chi tiết bài viết
 */
export default function NewsRouteHandler() {
  const location = useLocation();
  const [pageType, setPageType] = useState<PageType>('loading');
  const [categorySlug, setCategorySlug] = useState<string | undefined>();
  const [articleSlug, setArticleSlug] = useState<string | undefined>();

  useEffect(() => {
    const handleRoute = async () => {
      const pathname = location.pathname;
      
      // Pattern 0: /tin-tuc (exact) → Tất cả tin tức
      if (pathname === '/tin-tuc') {
        setCategorySlug(undefined);
        setPageType('category');
        return;
      }
      
      // Pattern 1: /tin-tuc-{slug} → Danh mục
      const categoryPattern = /^\/tin-tuc-([a-z0-9-]+)$/i;
      const categoryMatch = pathname.match(categoryPattern);
      
      if (categoryMatch) {
        const slug = categoryMatch[1];
        
        try {
          // Verify category exists
          const response = await getNewCategories();
          const categories: Category[] = response.data?.categories || [];
          const foundCategory = categories.find((cat: Category) => cat.slug === slug);
          
          if (foundCategory) {
            setCategorySlug(slug);
            setPageType('category');
            return;
          }
        } catch (error) {
          console.error('Error fetching categories:', error);
        }
        
        // Category not found
        setPageType('notfound');
        return;
      }
      
      // Pattern 2: /tin-tuc/{slug} → Chi tiết bài viết
      const detailPattern = /^\/tin-tuc\/(.+)$/i;
      const detailMatch = pathname.match(detailPattern);
      
      if (detailMatch) {
        const slug = detailMatch[1];
        setArticleSlug(slug);
        setPageType('detail');
        return;
      }
      
      // No pattern matched
      setPageType('notfound');
    };

    handleRoute();
  }, [location.pathname]);

  // Loading state
  if (pageType === 'loading') {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-[#00c897] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600 text-lg">Đang tải...</p>
        </div>
      </div>
    );
  }

  // Render appropriate page based on route type
  if (pageType === 'category') {
    return <NewsPage categorySlug={categorySlug} />;
  }

  if (pageType === 'detail') {
    return <NewsDetailPage slug={articleSlug} />;
  }

  // 404 Not Found
  return <NotFound />;
}

